import * as React from 'react';
import { forwardRef } from 'react';
const Loader = (props, ref) => {
    const prefixId = React.useId();
    return (React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("g", { clipPath: `url(#$${prefixId}__clip0_1733_261)`, fill: "var(--mollie-ui-icon-fill, currentColor)" },
            React.createElement("path", { d: "M7 1a1 1 0 0 1 2 0v3a1 1 0 0 1-2 0V1Z" }),
            React.createElement("path", { opacity: 0.6, d: "M7 12a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z" }),
            React.createElement("path", { opacity: 0.8, d: "M15 7a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2h3Z" }),
            React.createElement("path", { opacity: 0.4, d: "M4 7a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h3Z" }),
            React.createElement("path", { opacity: 0.9, d: "M12.243 2.343a1 1 0 1 1 1.414 1.415l-2.121 2.12a1 1 0 1 1-1.415-1.413l2.122-2.122Z" }),
            React.createElement("path", { opacity: 0.5, d: "M4.465 10.121a1 1 0 1 1 1.414 1.414l-2.122 2.122a1 1 0 0 1-1.414-1.415l2.122-2.12Z" }),
            React.createElement("path", { opacity: 0.7, d: "M13.657 12.243a1 1 0 0 1-1.414 1.414l-2.122-2.121a1 1 0 1 1 1.415-1.415l2.12 2.122Z" }),
            React.createElement("path", { opacity: 0.3, d: "M5.879 4.464a1 1 0 1 1-1.414 1.414l-2.122-2.12a1 1 0 1 1 1.415-1.415l2.12 2.121Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: `$${prefixId}__clip0_1733_261` },
                React.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" })))));
};
const ForwardRef = forwardRef(Loader);
export default ForwardRef;
ForwardRef.displayName = 'Loader';
//# sourceMappingURL=Loader.js.map